<template>
 <!-- Modal -->
  <div class="content-box-gray card modal fade" id="display-page-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header title text-center">
          <button type="button" onclick="javascript::player.api('pause')" class="close" data-dismiss="modal" aria-label="Close">
            <small aria-hidden="true">&times;</small></button>
          <h6 class="modal-title" id="myModalLabel" v-html="pageTitle" ></h6>
        </div>
        <div class=" content modal-body">
            <lettersdisplayselection :hidden="!flags.showLettersDisplay" ></lettersdisplayselection>
            <fsvisiondisplay :hidden="!flags.showFSVisionDisplay" ></fsvisiondisplay>
            <kssdisplay :hidden="!flags.showKSSDisplay" ></kssdisplay>
            <actionhabitsdisplay :hidden="!flags.showActionHabitsDisplay" ></actionhabitsdisplay>
        <div id="textDisplay" v-if="displayText" v-html="displayText"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '../../../event-bus';
import lettersdisplayselection from '../../comms/inserts/LettersDisplaySelection.vue';
import fsvisiondisplay from '../../fself/inserts/FSVisionDisplay.vue';
import kssdisplay from '../../kill_self_sabotage/inserts/KSSDisplaySelection.vue';
import actionhabitsdisplay from '../../action_habits/inserts/ActionHabitsDisplaySelection.vue';

export default {
    components:{
    lettersdisplayselection,
    fsvisiondisplay,
    kssdisplay,
    actionhabitsdisplay,

     },
    name: "GenericPageDisplayModal",
    data() {
        return {
            pageTitle:'',
            displayText:'',
            showLettersDisplay:false,
            showFSVisionDisplay:false,
            showKSSDisplay:false,
            showActionHabitsDisplay: false,
            flags:{},
        }
    },

    props: {
    },
    mounted() {
        EventBus.$on('displayPageModal', (data) => {
            // console.error("Generic Page Display modal invoked");
            console.log("display: " + data.display);
            console.log("Title: " + data.title);
            this.pageTitle = data.title;
            // if(data.display == 'lettersdisplay') {this.showLettersDisplay = true; this.showLettersDisplay= this.showFSVisionDisplay=this.showKSSDisplay= this.showActionHabitsDisplay = false;}
            // if(data.display == 'fs_visiondisplay') {this.showFSVisionDisplay = true;this.showLettersDisplay=this.showKSSDisplay= this.showActionHabitsDisplay = false;}
            // if(data.display == 'kssdisplay') {this.showKSSDisplay = true; this.showFSVisionDisplay = false;this.showLettersDisplay = false; }
            // if(data.display == 'actionhabitsdisplay') {this.showActionHabitsDisplay = true; this.showFSVisionDisplay = false;this.showKSSDisplay = this.showLettersDisplay = false; }
            if(data.display == 'lettersdisplay') this.updateFlags('showLettersDisplay');
            if(data.display == 'fs_visiondisplay') this.updateFlags('showFSVisionDisplay');
            if(data.display == 'kssdisplay') this.updateFlags('showKSSDisplay');
            if(data.display == 'actionhabitsdisplay') this.updateFlags('showActionHabitsDisplay');
            // console.log("Show letters: " + this.showLettersDisplay + ", ShowVision: " + this.showFSVisionDisplay);
            $('div#display-page-modal').modal('show');
        });
    //  this.setupVideoBGStop();//set a shutdown on closing the video popup (else the audio continues)
    },


    methods: {
        updateFlags(selectedVar) {
            this.flags = {
                showLettersDisplay: false,
                showFSVisionDisplay: false,
                showKSSDisplay: false,
                showActionHabitsDisplay: false,
            };
            this.flags[selectedVar] = true;
            // return flags;
        },
      resetFlags(selectedVar) {
            this.flags = {
                showLettersDisplay: false,
                showFSVisionDisplay: false,
                showKSSDisplay: false,
                showActionHabitsDisplay: false,
            };

        },
        beforeDestroy() {
            this.cleanup();
        },
        cleanup(){
            this.pageTitle = '';
            this.displayText = '';
            this.resetFlags();
        },
        cancel() {
            this.cleanup();
            $('div#display-page-modal').modal('hide');
        },

    }
}
</script>

<style scoped>
.content-box-gray .content {
    overflow:    ;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
    background:#ffc107;
    font-size:.75em;
    /* font-weight:bold; */
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}
#textDisplay{
    font-size: x-small;
}

</style>
